<template>
    <div class="table-user">
        <div class="table-user-header">
            <div class="pb-3 text-right pt-1">
                <b-btn variant="primary-user"
                       size="sm"
                       :to="{name: 'AddProducts'}">Add a product
                </b-btn>
                <b-btn type="button"
                       class="btn-double-angle ml-2"
                       variant="primary-user"
                       size="sm"
                       @click="additionalFilters = !additionalFilters">Additional Filters
                </b-btn>
                <b-btn class="ml-2"
                       variant="primary-user"
                       size="sm"
                       @click="openTableSettingsModal">Table Settings
                </b-btn>
            </div>
            <b-row class="pb-3" v-if="additionalFilters">
                <search-field @searchValue="searchField($event)"></search-field>
                <date-filters @dateFromAction="filterTable($event)" @dateToAction="filterTable($event)"/>
                <price-filters @priceGreater="filterTable($event)" @priceLess="filterTable($event)" />
            </b-row>
        </div>
        <div class="scroll-x">
            <table-element
                :items="items"
                :fields="tableFields"
                :status="statusOptions"
                @statusFiltered="event => filterTable(event)"
                @sort="event => sortTable(event)">
                <b-form-checkbox
                    slot="HEAD_checkboxes"
                    slot-scope="data"
                    v-model="allCheckboxes"
                    @click.native.stop="selectedAll"
                    name="checkbox-column"
                    class="custom-control-user">
                    All
                </b-form-checkbox>
                <b-form-checkbox
                    slot="checkboxes"
                    slot-scope="data"
                    name="checkboxes"
                    :key="'checkbox'+data.index"
                    :value="data.item.id"
                    v-model="selectedCheckbox"
                    @click.native.stop
                    class="custom-control-user">
                </b-form-checkbox>
                <product-actions slot="actions"
                                 slot-scope="data"
                                 :product-id="data.item.id"
                                 @showPlanModal="showPlanModal([...data.item.id])"
                                 :update-list="getItems"/>
            </table-element>
        </div>
        <div class="table-user-footer">
            <!-- Pagination -->
            <table-pagination
                v-if="settingsPaginationFromApi.total >= quantityProductOnPage"
                @paginateAction="updatePagination"
                :settings="settingsPaginationFromApi"
                :perPageArray="quantityProductVariations"/>
            <div class="action-button">
                <b-btn class="mr-2"
                       variant="primary-user"
                       :disabled="disabledBtn"
                       @click="multipleProductActions('delete')">
                    Delete
                </b-btn>
                <b-btn class="mr-2"
                       variant="primary-user"
                       :disabled="disabledBtn"
                       @click="multipleProductActions('addToArchive')">
                    Archive
                </b-btn>
                <b-btn class="mr-2"
                       variant="primary-user"
                       :disabled="disabledBtn"
                       @click="multipleProductActions('addToReturn')">
                    Add to Return order
                </b-btn>
                <b-btn class="mr-2"
                       variant="primary-user"
                       :disabled="disabledBtn"
                       @click="showPlanModal(selectedCheckbox)">
                    Add to Restock plan
                </b-btn>
            </div>
        </div>
        <modal-table-settings :tableSettings="inventoryColumn"
                              :defaultTableSettings="defaultInventoryColumn"
                              :selectedColumns="$store.state.inventoryManagementColumns"
                              :localStorageItemName="'inventoryManagementColumns'"
                              :storeCommitName="'UPDATE_INVENTORY_COLUMNS'"/>
        <shipping-plan-modal
            @done="id => $router.push({name: 'ReplenishmentItem', params: {parent: 'plans', planId: id}})"
            :items="productsId"/>
    </div>
</template>

<script>
    import {tableMixins, paginationMixin, routePaginationMixin, rowSelectMixin} from '@/mixins/tableMixins'

    import TableElement from '~cp/UserPanel/Elements/TableElement'
    import SearchField from '~cp/UserPanel/Elements/SearchField'
    import DateFilters from '~cp/UserPanel/Elements/DateFilters'
    import PriceFilters from '~cp/UserPanel/Elements/PriceFilters'
    import ProductActions from '~user-pages/Inventory/Management/ProductActions'
    import ShippingPlanModal from '~cp/UserPanel/Modals/ShippingPlanModal'
    import ModalTableSettings from '~cp/UserPanel/Modals/ManagementTableSettings'
    import TablePagination from '~cp/UserPanel/Elements/TablePagination'

    import inventoryStatus from '@/assets/js/status/inventoryManagement'
    import defaultInventoryManagement from '@/assets/js/columns/defaultInventoryManagement'
    import inventoryManagement from '@/assets/js/columns/inventoryManagement'

    export default {
        name: 'InventoryManagement',
        mixins: [tableMixins, paginationMixin, routePaginationMixin, rowSelectMixin],
        components: {
            TableElement,
            SearchField,
            DateFilters,
            PriceFilters,
            ProductActions,
            ShippingPlanModal,
            ModalTableSettings,
            TablePagination
        },
        data() {
            return {
                productsId: [],
                additionalFilters: false,
                statusOptions: inventoryStatus,
                inventoryColumn: inventoryManagement,
                defaultInventoryColumn: defaultInventoryManagement,
                requiredApiParams: {},
            }
        },
        computed: {
            tableFields() {
                const {inventoryManagementColumns} = this.$store.state
                return [this.checkboxesColumn, ...inventoryManagementColumns, this.actionsColumn]
            },
        },
        methods: {
            openTableSettingsModal() {
                this.$root.$emit('bv::show::modal', 'tableSettings')
            },
            showPlanModal(data) {
                this.productsId = data
                this.$nextTick(() => {
                    this.$root.$emit('bv::show::modal', 'shipping-plan-modal')
                })
            },
            multipleProductActions(action) {
                if (action === 'delete') {
                    this.selectedCheckbox.forEach((id) => {
                        this.$store.dispatch('deleteProduct', id).then(() => this.getItems)
                    })
                } else {
                    this.selectedCheckbox.forEach((id) => {
                        this.$store.dispatch('productActions', this.$endpoints[action](id))
                    })
                }
                this.resetCheckbox()
            },
        }
    }
</script>

<style lang="scss" scoped>
    .table-user {
        .scroll-x {
            min-height: calc(100vh - 410px);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Management/InventoryManagement.vue